import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type ProductCardFormType } from '@web/widgets/product-card/type';
import { type AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-product-price',
    templateUrl: './product-price.component.html',
    styleUrls: ['./product-price.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, TranslateModule],
})
export class ProductPriceComponent {
    @Input() price: ProductCardFormType['price'];
    @Input() oldPrice: ProductCardFormType['oldPrice'];

    public validateInputValue(value: string, control: AbstractControl) {
        control.setValue(this.checkMinRange(value));
    }

    private checkMinRange(value: string): number {
        if (value === '') return null;

        return +value >= 0 && value !== null ? +value : null;
    }
}
